import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from 'AppPaths';

import { T8y } from 'ui';
import MainProductPrice from 'ui/ProductCard/MainProductPrice';

import defaultImageProduct from 'assets/images/pictures/wilko/product-fallback.png';

import style from './postcodeSuggestions.module.scss';

export const PostcodeSuggestions = ({ products, currProduct = {} }) => {
  const formattedProducts = useMemo(() => {
    let currWeightCapacity = currProduct.weightCapacity
      .split('-')
      .map((el) => Number(el));

    const currModifiedProduct = {
      ...currProduct,
      weightCapacity: currWeightCapacity,
    };

    currWeightCapacity =
      currWeightCapacity.length > 1
        ? currWeightCapacity[1]
        : currWeightCapacity[0];

    const allWeightCapacity = products.map((el) => ({
      ...el,
      weightCapacity: el.weightCapacity?.split('-').map((el) => Number(el)) || [
        1,
      ],
    }));

    if (
      !products.find((el) => el.weightCapacity === currProduct.weightCapacity)
    ) {
      const nextElIndex = allWeightCapacity.findIndex(
        (el) =>
          el.weightCapacity.every((weight) => weight > currWeightCapacity),
        [],
      );

      if (nextElIndex === -1) {
        allWeightCapacity.push(currModifiedProduct);
      } else {
        allWeightCapacity.splice(
          nextElIndex === 0 ? nextElIndex : nextElIndex - 1,
          0,
          currModifiedProduct,
        );
      }
    }

    const currentSkipIndex = allWeightCapacity.findIndex((el) => {
      if (el.weightCapacity.length === 1) {
        return el.weightCapacity[0] === currWeightCapacity;
      }

      // 14-16 for example
      return (
        el.weightCapacity[0] <= currWeightCapacity &&
        currWeightCapacity <= el.weightCapacity[1]
      );
    });

    let start = currentSkipIndex - 2;
    let end = currentSkipIndex + 3;

    if (start < 0) {
      start = 0;
      end = 5;
    }
    if (end > allWeightCapacity.length) {
      end = allWeightCapacity.length;
      start = end - 4 < 0 ? 0 : end - 4;
    }

    return allWeightCapacity
      .slice(start, end)
      .filter(
        (el) =>
          el.weightCapacity.join('') !==
          currModifiedProduct.weightCapacity.join(''),
      );
  }, [currProduct, products]);

  if (!formattedProducts.length) {
    return null;
  }

  return (
    <div className={style.suggestions}>
      <T8y
        className={style.suggestionsTitle}
        xsVariant="t1"
        color="wilkoBlack"
        bold
        mb3
      >
        Available skips in your location
      </T8y>
      <div>
        {formattedProducts.map((el) => (
          <Link
            to={PATHS.PRODUCT(el.slug)}
            key={el.id}
            className={style.productSuggestion}
          >
            <div className={style.productSuggestionImageWrapper}>
              <img
                className={style.productImage}
                src={el.imageThumb || defaultImageProduct}
                alt="ProductParts img"
              />
            </div>
            <div className={style.suggestionInfo}>
              <T8y
                className={style.productSuggestionNameWrapper}
                as="p"
                variant="t1v2"
                bold
              >
                {el.name}
              </T8y>
              <div className={style.mainProductSuggestionPriceWrapper}>
                <MainProductPrice mainPrice={el.price || 0} isNoFrom />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
